/** Цифры национальной части (10 цифр без кода страны). */
export function extractNationalPhoneDigits(input: string): string {
  let digits = input.replace(/\D/g, "");
  if (!digits) return "";

  if (digits.startsWith("8") || digits.startsWith("7")) {
    digits = digits.slice(1);
  }

  return digits.slice(0, 10);
}

/** Полный номер: 11 цифр, первая 7. */
export function normalizePhoneDigits(input: string): string {
  const national = extractNationalPhoneDigits(input);
  if (!national) return "";
  return `7${national}`;
}

export function formatNationalPhonePart(digits: string): string {
  const national = digits.replace(/\D/g, "").slice(0, 10);
  if (!national) return "";
  if (national.length <= 3) return national;
  if (national.length <= 6) {
    return `(${national.slice(0, 3)}) ${national.slice(3)}`;
  }
  if (national.length <= 8) {
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
  }
  return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6, 8)}-${national.slice(8, 10)}`;
}

export function formatPhoneNumber(input: string): string {
  const national = extractNationalPhoneDigits(input);
  if (!national) return "";
  return `+7 ${formatNationalPhonePart(national)}`;
}

export function formatNationalPhoneInput(
  input: string,
  cursor: number,
): { value: string; cursor: number } {
  const digitsBeforeCursor = input.slice(0, cursor).replace(/\D/g, "").length;
  const national = extractNationalPhoneDigits(input);
  const value = formatNationalPhonePart(national);

  if (!value) {
    return { value: "", cursor: 0 };
  }

  let newCursor = 0;
  let seenDigits = 0;

  for (let index = 0; index < value.length; index += 1) {
    if (/\d/.test(value[index] ?? "")) {
      if (seenDigits >= digitsBeforeCursor) {
        newCursor = index;
        break;
      }
      seenDigits += 1;
    }
    newCursor = index + 1;
  }

  return { value, cursor: newCursor };
}

export function parseStoredPhoneValue(value: string): string {
  return extractNationalPhoneDigits(value);
}
